import React, { createContext, useContext, useState } from 'react';

type Coordinates = [number, number] | null;

interface LocationContextType {
  coordenadas: Coordinates;
  setCoordenadas: (coords: Coordinates) => void;
}

const LocationContext = createContext<LocationContextType | undefined>(undefined);

export const LocationProvider = ({ children }: { children: React.ReactNode }) => {
  const [coordenadas, setCoordenadas] = useState<Coordinates>(null);

  return <LocationContext.Provider value={{ coordenadas, setCoordenadas }}>{children}</LocationContext.Provider>;
};

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) throw new Error('useLocation must be used within a LocationProvider');
  return context;
};
